import { RouterProvider } from 'react-router-dom'
import { AuthProvider } from '@/providers/auth-provider'
import { ThemeProvider } from '@/providers/theme-provider'
import { ApiProvider } from '@/providers/api-provider'
import { ErrorBoundaryClass } from '@/components/ErrorBoundary'
import { router } from '@/routes'

export function App() {
  return (
    <ErrorBoundaryClass level="app">
      <ThemeProvider>
        <AuthProvider>
          <ApiProvider>
            <RouterProvider router={router} />
          </ApiProvider>
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundaryClass>
  )
}
